import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DialogBase, DialogOptions } from '@marmon/frontend/common';
import { TuiButton } from '@taiga-ui/core';

type ConfirmOptions = {
	acceptText?: string;
	cancelText?: string;
	description: string;
	translationParams?: object;
};

@Component({
	standalone: true,
	imports: [TranslocoPipe, TuiButton],
	selector: 'mar-confirm-dialog',
	templateUrl: 'confirm-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent extends DialogBase<
	boolean,
	ConfirmOptions
> {
	static override readonly DialogOptions = { size: 's' } as DialogOptions;

	readonly cancelText = computed(() => {
		return this.context.data.cancelText ?? 'action.no';
	});
	readonly acceptText = computed(() => {
		return this.context.data.acceptText ?? 'action.yes';
	});

	readonly onAccept = () => this.onDismiss(true);
}
